import { call, put } from "redux-saga/effects";
import { MLAPI } from "api";
import {
  SECURITY_GET_USER_SUCCESSFUL,
  SECURITY_GET_USER_ERROR
} from "UserAuthorized/actionTypes";
import User from "contracts/responses/User";

export function* getUser(action) {
  const { response, error } = yield call(
    MLAPI.security.getUser,
    action.payload
  );
  if (response)
    yield put({
      type: SECURITY_GET_USER_SUCCESSFUL,
      payload: new User(response.data.data)
    });
  else yield put({ type: SECURITY_GET_USER_ERROR, payload: error });
}
